/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputLabel = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  padding-bottom: 8px;
  color: #111827;
`;
